var map = {
	"./food1.png": 404,
	"./food2.png": 263,
	"./food3.png": 326,
	"./food4.png": 57,
	"./food5.png": 936,
	"./food6.png": 267,
	"./food7.png": 442,
	"./food8.png": 293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;